import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Avatar from '@material-ui/core/Avatar';
import FieldDataType from './FieldDataType';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(1),
    },
    table: {
        minWidth: 500,
    },

    halfPointPadding: {
        padding: theme.spacing(0.5),
    },

    onePointPadding: {
        padding: theme.spacing(1),
    },

    cardTitle: {
        borderTopRightRadius: 5,
        borderTopLeftRadius: 5,
        backgroundColor: 'lightgrey',
        padding: 3
    },

}));

function Service( props ) {
    const classes = useStyles();
    let srv = props.srv;
    let udtDetailsComp = props.udtDetailsComp;

    let fqn = srv.Name.FullyQualifiedName
    var n = fqn.lastIndexOf(".");
    var namespace = ""

    if ( n > 0 )
        namespace = fqn.substr(0,n);

    function includesDecl(incs) {
        if ( incs == null || incs.length === 0 )
            return null
        else
            return (
                <span className={classes.onePointPadding}>
                    <b>Includes:</b>
                    { incs.map( (e,index) => {
                        return ( <span key={index} className={classes.halfPointPadding}>
                            <FieldDataType parentNamespace={namespace} dtype={e} udtDetailsComp={udtDetailsComp} />
                        </span> )
                    } ) }
                </span>
            );
    }

    function showDependants( deps ) {

        if ( deps == null || deps.length === 0 )
            return null
        else

            return (
                <div className={classes.onePointPadding}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="usage-content"
                            id="usages-header"
                        >
                            <Typography className={classes.heading}>Usages</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            {
                                deps.map( (d,index) => {
                                    if ( d.IsSynthetic === true )
                                        return (<span key={index}/>)
                                    else
                                        return ( <div key={index} style={{ width: '100%' }}>
                                            <Box display="flex" flexWrap="wrap">
                                                <span className={classes.halfPointPadding}>
                                                    <FieldDataType parentNamespace={namespace} dtype={d} withAvatar={true} udtDetailsComp={udtDetailsComp} />
                                                </span>
                                            </Box>
                                        </div> )
                                } )
                            }
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
        )
    }

    function formalsTemplate(rowData, column) {
        let formals = rowData['formals']

        if ( Object.keys(formals).length === 0 )
            return ""
        else 
            return (
                <DataTable value={
                    Object.keys(formals).map( (formalName,index) => {
                        let f = formals[formalName]
                        return {
                            key: index,
                            name: f.Name,
                            type: f.DataType,
                            doc: f.Doc,
                            default: f.DefaultValue
                        }
                    })                
                }
                >
                    <Column field="name" header="Name" style={{width: '6em'}} />
                    <Column field="type" header="Data Type" body={dataTypeTemplate} />
                    <Column field="doc" header="Comments" />
                </DataTable>             
            )
    }

    function dataTypeTemplate(rowData, column) {
        return <span><FieldDataType parentNamespace={namespace} dtype={rowData['type'] } withAvatar={true} udtDetailsComp={udtDetailsComp} /></span>;
    }

    function makeTableData() {
        return Object.keys(srv.MethodSignatures).map( (methodName,index) => {
            let f = srv.MethodSignatures[methodName]
            return {
                    key: index,
                    name: f.Name,
                    formals: f.Formals,
                    type: f.ReturnType,
                    doc: f.Doc
            }
        });
    }

    return (
        <div className={classes.root}>
            <Paper className={classes.root}  >
                <div className={classes.cardTitle}>

                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <div className={classes.halfPointPadding}><Avatar>Svc</Avatar></div>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h3">
                                {srv.Name.FullyQualifiedName}
                            </Typography>
                        </Grid>
                    </Grid>
                </div>

                <div className={classes.onePointPadding}>
                    <Typography component="p">
                        {srv.Doc}
                    </Typography>

                    <div style={{ width: '100%' }}>
                        <Box display="flex" flexWrap="wrap">
                            <div className={classes.onePointPadding}>
                            </div>
                        </Box>

                        { includesDecl(srv.Includes) }
                    </div>
                </div>

                <div className={classes.onePointPadding}>
                    <Paper>
                        <div className={classes.cardTitle}>
                            <Typography variant="h6" component="h3" >
                                Constructor Arguments
                            </Typography>
                        </div>

                        <DataTable value={
                            Object.keys(srv.ConstructorFormals).map( (fieldName,index) => {
                                let f = srv.ConstructorFormals[fieldName]
                                return {
                                        key: index,
                                        name: f.Name,
                                        type: f.DataType,
                                        doc: f.Doc,
                                        default: f.DefaultValue
                                }
                            })
                        }>
                            <Column field="name" header="Name"  style={{width: '10em'}} />
                            <Column field="type" header="Type" style={{width: '20em'}} body={dataTypeTemplate} />
                            <Column field="default" header="Default"  />
                            <Column field="doc" header="Comments" />
                        </DataTable>     
                    </Paper>
                </div>

                <div className={classes.onePointPadding}>
                    <Paper>
                        <div className={classes.cardTitle}>
                            <Typography variant="h6" component="h3" >
                                Methods
                            </Typography>
                        </div>

                        <DataTable value={makeTableData()}>
                            <Column field="name" header="Name" style={{width: '10em'}} />
                            <Column field="formals" header="Arguments" body={formalsTemplate} />
                            <Column field="returnType" header="Return Type" style={{textAlign:'left', width: '20em'}} body={dataTypeTemplate} />
                            <Column field="doc" header="Comments" />
                        </DataTable>     
                    </Paper>
                </div>

                { showDependants(srv.ImmediateDependants) }

            </Paper>
        </div>
    );
}

export default Service;